import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, toRefs
} from 'vue';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import { templateRef, useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String as PropType<'home' | 'user-search' | 'table' | 'messenger'>,
      default: 'home',
    },
    maxlength: {
      type: [String, Number, Boolean],
      default: 160
    },
    showSearchIcon: {
      type: Boolean,
      default: true
    },
    enterEvent: {
      type: Function as () => any,
      default: () => null,
      required: false,
    },
    iconEvent: {
      type: Function as PropType<CallableFunction>,
      default: null,
    },
    placeholder: {
      type: String,
      default: undefined
    },
    invertOnContent: Boolean
  },
  setup(__props) {

const props = __props;



const { type } = toRefs(props);
const isFocussed = ref(false);
const inputVM = useVModel(props);
const isSearchExpanded = ref(false);
const input = templateRef<HTMLInputElement>('input');

const isExpanded = computed(() => type.value === 'messenger' || isFocussed.value || inputVM.value || isSearchExpanded.value);
const showInputField = computed(() => ['home', 'user-search', 'table'].includes(type.value ?? '') || isExpanded.value);

const clear = () => {
  inputVM.value = '';
  isSearchExpanded.value = false;
};

const onFocus = () => { isFocussed.value = true; };
const onBlur = () => {
  isFocussed.value = false;
  isSearchExpanded.value = false;
};

const hasDeleteIcon = computed(() => (
  (type.value === 'messenger' || type.value === 'table')
        && !!inputVM.value
) || type.value === 'user-search');


return { __sfc: true,props, type, isFocussed, inputVM, isSearchExpanded, input, isExpanded, showInputField, clear, onFocus, onBlur, hasDeleteIcon, BCXIcon }
}

})